<template>
  <div class="company-user-item-info-bd">
    <div class="user-info">
      <el-form label-position="top" :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item key="userCode" :label="$t('company_user_item_info.yong_hu_bian_ma')" prop="userCode">
          <el-input v-model="form.userCode" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="realName" :label="$t('company_user_item_info.yuan_gong_xing_ming')" prop="realName">
          <el-input v-model="form.realName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="loginPwd" v-if="type == 'add'" :label="$t('company_user_item_info.deng_lu_mi_ma')" prop="loginPwd">
          <el-input
            autocomplete="off"
            :type="inputType"
            :readonly="inputReadonly"
            v-model="form.loginPwd"
            :placeholder="$t('company_user_item_info.mmcdw816wbszfhzmrylz')"
            style="width: 100%"
            :disabled="!!userId"
            @focus="
              inputReadonly = false;
              inputType = 'text';
            "
            @blur="inputType = 'password'"
          ></el-input>
        </el-form-item>
        <el-form-item key="mobile" :label="$t('company_user_item_info.lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="email" :label="$t('Common.com_email')" prop="email">
          <el-input v-model="form.email" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="langCode" :label="$t('company_user_item_info.mo_ren_yu_zhong')" prop="langCode">
          <custom-select v-model="form.langCode" code="language_type" :isDefault="type === 'add'" width="100%" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <el-form-item key="timeZoneId" :label="$t('company_user_item_info.mo_ren_shi_qu')" prop="timeZoneId" v-if="timeZoneIdList.length > 1">
          <custom-select v-model="form.timeZoneId" url="timeZoneGetCompanyList" :clearable="false" width="100%" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
        </el-form-item>
        <el-form-item key="dateFormat" :label="$t('company_user_item_info.rqxsgs')" prop="dateFormat">
          <custom-select v-model="form.dateFormat" code="bas_date_format" width="100%"></custom-select>
        </el-form-item>
        <el-form-item key="isTime24h" :label="$t('company_user_item_info.24xiao_shi_zhi')" prop="isTime24h">
          <custom-select v-model="form.isTime24h" code="isynergy_cloud_bool" width="100%"></custom-select>
          <!-- <el-switch v-model="form.isTime24h" :active-value="1" :inactive-value="0"></el-switch> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="footer ub ub-xc ub-ae">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="saveUser()">{{ $t('company_user_item_info.xia_yi_bu') }}</el-button>
      <el-button type="warning" v-if="type === 'edit'" @click="saveUser()">{{ $t('Common.com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    type: String,
    userId: [String, Number],
  },
  data() {
    return {
      inputReadonly: true,
      inputType: 'text',
      form: {
        userCode: '',
        realName: '',
        // userName: '',
        loginPwd: '',
        mobile: '',
        langCode: '',
        email: '',
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      },
      timeZoneIdList: [],
    };
  },
  computed: {
    rules() {
      return {
        loginPwd: [
          {
            min: 8,
            max: 16,
            message: this.$t('company_user_item_info.mmcdw816wbszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('company_user_item_info.mmcdw816wbszfhzmrylz'),
          },
        ],
        mobile: {
          min: 7,
          max: 11,
          message: this.$t('company_user_item_info.sjhcdbxw711w'),
        },
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('company_user_item_info.yxgsbzq'),
          },
          { max: 50, message: ' ' },
        ],
      };
    },
  },
  mounted: function () {
    this.getUserDate();
    this.getTimeZoneIdList();
    this.rules.loginPwd[1].validator = (rule, value, callback) => {
      const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
      if (!reg.test(value.toString())) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },
  methods: {
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    // 获取用户信息
    getUserDate: function () {
      if (this.type === 'edit') {
        this.$getJSON(`${apis.User}/${this.userId}`).then((res) => {
          this.$setFormatData(this.form, res.data);
        });
      }
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 下一步
    onStep: function (userId) {
      this.$emit('step', {
        name: 'info',
        userId: userId,
        realName: this.form.realName,
      });
    },
    // 确认保存用户
    saveUser: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.type === 'add' && !this.userId) {
          this.saveAddUser();
        } else {
          this.saveEditUser();
        }
      });
    },
    // 保存新增用户
    saveAddUser: function () {
      this.$postJSON(apis.UserAdd, Object.assign({}, this.form, { loginPwd: this.encrypt(this.form.loginPwd) })).then((res) => {
        const userId = res.data || '';
        this.onStep(userId);
      });
    },
    // 保存编辑用户
    saveEditUser: function () {
      this.$postJSON(apis.UserUpdate, {
        userId: this.userId,
        realName: this.form.realName,
        userCode: this.form.userCode,
        mobile: this.form.mobile,
        sex: this.form.sex,
        langCode: this.form.langCode,
        email: this.form.email,
        timeZoneId: this.form.timeZoneId,
        dateFormat: this.form.dateFormat,
        isTime24h: this.form.isTime24h,
      }).then(() => {
        if (this.type === 'add') {
          this.onStep(this.userId);
        } else {
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-item-info-bd {
  .user-info {
    padding: 24px;
  }
  .footer {
    height: 88px;
    padding: 0 24px;
    background: #f8f9fa;
  }
}
</style>
